import { mountCircuit3dEditor, type Circuit3dEditorHandle } from './circuit3dEditor.js';
import type { SavedCircuit } from './api.js';
import type { CircuitEditorSource } from './circuitEditor.js';

export interface Circuit3dEditorModal {
  open: (circuit: CircuitEditorSource) => void;
  close: () => void;
}

/** Éditeur de circuit 3D en plein écran — coexiste avec l'éditeur 2D existant. */
export function mountCircuit3dEditorModal(
  host: HTMLElement,
  onSaved?: (saved: SavedCircuit) => void
): Circuit3dEditorModal {
  const backdrop = document.createElement('div');
  backdrop.className = 'modal-backdrop circuit-3d-modal';
  backdrop.hidden = true;
  backdrop.setAttribute('role', 'dialog');
  backdrop.setAttribute('aria-modal', 'true');
  backdrop.setAttribute('aria-labelledby', 'circuit-3d-editor-modal-title');

  backdrop.innerHTML = `
    <div class="modal circuit-3d-modal-dialog">
      <div class="modal-header circuit-3d-modal-header">
        <h2 id="circuit-3d-editor-modal-title" class="circuits-generate-title">Éditeur de circuit</h2>
        <button type="button" class="btn btn-ghost circuit-3d-modal-close" aria-label="Fermer">×</button>
      </div>
      <div class="modal-body circuit-3d-modal-body">
        <div class="circuit-3d-editor-host"></div>
      </div>
    </div>`;

  host.appendChild(backdrop);

  const editorHost = backdrop.querySelector('.circuit-3d-editor-host') as HTMLElement;
  let active: Circuit3dEditorHandle | null = null;

  const close = (): void => {
    backdrop.hidden = true;
    active?.dispose();
    active = null;
    editorHost.innerHTML = '';
  };

  const open = (circuit: CircuitEditorSource): void => {
    backdrop.hidden = false;
    active?.dispose();
    active = mountCircuit3dEditor(editorHost, circuit, onSaved);
  };

  backdrop.querySelector('.circuit-3d-modal-close')?.addEventListener('click', close);
  backdrop.addEventListener('click', (e) => {
    if (e.target === backdrop) close();
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && !backdrop.hidden) close();
  });
  backdrop.querySelector('.circuit-3d-modal-dialog')?.addEventListener('click', (e) => {
    e.stopPropagation();
  });

  return { open, close };
}
